import React from "react";
import { BOOKING_URL } from "@/lib/site";
import { BookLink } from "@/components/site/BookLink";
import { PageHero } from "@/components/site/Section";
import { REVIEWS } from "@/lib/content";
import { useContent } from "@/context/ContentContext";
import { Star } from "lucide-react";

export default function Reviews() {
  const { reviews = REVIEWS } = useContent();
  return (
    <div data-testid="reviews-page">
      <PageHero
        eyebrow="Client Reviews"
        title="Confidence Shared"
        subtitle="Kind words from clients who trusted Seraphina with their care."
      />
      <section className="py-20 bg-[var(--cream)]">
        <div className="max-w-[1100px] mx-auto px-5 lg:px-10 grid md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div key={i} className="soft-card rounded-2xl p-8 flex flex-col">
              <div className="flex gap-1 text-[var(--gold)] mb-4">
                {Array.from({ length: 5 }).map((_, j) => <Star key={j} size={16} fill="currentColor" />)}
              </div>
              <p className="font-display text-2xl text-[var(--charcoal)] leading-snug flex-1">“{r.quote}”</p>
              <p className="text-sm text-[var(--charcoal-soft)] mt-5 uppercase tracking-wider">— {r.name}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <BookLink label="Reviews Book" href={BOOKING_URL} className="btn-gold rounded-full px-8 py-3.5 inline-block">
            Book Your Visit
          </BookLink>
        </div>
      </section>
    </div>
  );
}
